import { render } from "./SuccessIcon.vue?vue&type=template&id=3df09b81"
import script from "./SuccessIcon.vue?vue&type=script&lang=js"
export * from "./SuccessIcon.vue?vue&type=script&lang=js"
script.render = render

export default script